import { axiosClient } from 'www/utils'
import { PATIENT_PROFILE_API_PATH } from 'www/vue_components/common/PatientProfile/constants'

function getPatientData({ patientId, patientProfileId }) {
  const currentLanguageIso = window.LANGUAGE_DATA.currentLanguage.iso
  const headers = { 'PD-Translation-Language': currentLanguageIso }

  return new Promise((resolve, reject) => {
    axiosClient.get(PATIENT_PROFILE_API_PATH, {
      params: {
        patient_id: patientId,
        patient_profile_id: patientProfileId,
      },
      headers,
    })
      .then(res => resolve(res.data))
      .catch(reject)
  })
}

export default getPatientData
